import { PackageTypes } from 'shared-widget-components/src/constants/Constants';
import { WinePackageModel, WinePackageWidgetModel } from '../../models/WinePackageWidgetModel';
import { useFeaturedProductContext } from 'shared-widget-components/src/providers/FeaturedProductProvider';
import { CustomWinePackages } from './CustomWinePackages';
import { FeaturedWinePackages } from './FeaturedWinePackages';

interface WinePackagesProps {
  item: WinePackageModel;
  winePackageList: WinePackageWidgetModel[];
}

export const WinePackages = ({ item, winePackageList }: WinePackagesProps) => {
  const { featuredPackages } = useFeaturedProductContext();

  if (item.type == PackageTypes.FEATURED) {
    return <FeaturedWinePackages item={item} winePackageList={featuredPackages} />;
  }

  return <CustomWinePackages item={item} winePackageList={winePackageList} />;
};
